// extracted by mini-css-extract-plugin
export var $animation_name = "TabGallery-module--$animation_name--35e65";
export var animateIn = "TabGallery-module--animateIn--5b99d";
export var tabGallery = "TabGallery-module--tabGallery--83974";
export var tabGallery__cover = "TabGallery-module--tabGallery__cover--17229";
export var tabGallery__image = "TabGallery-module--tabGallery__image--52f50";
export var tabGallery__image___usp = "TabGallery-module--tabGallery__image___usp--c02eb";
export var tabGallery__image___uspBox = "TabGallery-module--tabGallery__image___uspBox--ada85";
export var tabGallery__label = "TabGallery-module--tabGallery__label--8f7e4";
export var tabGallery__label___arrow = "TabGallery-module--tabGallery__label___arrow--f17ec";
export var tabGallery__label___arrowOpen = "TabGallery-module--tabGallery__label___arrowOpen--f8f45";
export var tabGallery__label___button = "TabGallery-module--tabGallery__label___button--274e0";
export var tabGallery__label___content = "TabGallery-module--tabGallery__label___content--ff12f";
export var tabGallery__label___title = "TabGallery-module--tabGallery__label___title--0c901";
export var tabGallery__openMenu = "TabGallery-module--tabGallery__openMenu--92238";
export var tabGallery__video = "TabGallery-module--tabGallery__video--288d2";
export var tabGallery__videoWrapper = "TabGallery-module--tabGallery__videoWrapper--c90a8";